define('controllers/changeusername',['require'],function(require) {
    return function() {
        //check username
        $("#txtUsername").on("change", function () {
            var checkingUserName = $("#checkingUserName"),
                userNameInUse = $("#userNameInUse"),
                $this = $(this),
                userName = $this.val().trim();

            userNameInUse.hide();
            $this.removeAttr("style");

            if (userName.length > 0) {
                checkingUserName.show();

                $.ajax({
                    type: 'POST',
                    url: "/registration/UserNameCheckAJAX.aspx",
                    data: { UserName: userName },
                    success: function (response) {
                        response === "True" ? $this.css({ border: "1px solid #3A87AD" }) : userNameInUse.show();
                        checkingUserName.hide();
                    },
                    error: function () {
                        //errorMessage.show().html("Something went wrong. Please re-load the page and try again or contact Adestinn Support.");
                        checkingUserName.hide();
                    }
                });
            }
        });
    };
});

